import React from 'react';
import { Link } from 'react-router-dom';

function DetailsHeader() {
  return (
    // === CHANGED ===
    // Increased fixed height from h-16 to h-20 (5rem / 80px).
    <header className="flex items-center justify-between whitespace-nowrap border-b border-solid border-b-gray-300 px-4 sm:px-10 h-20 bg-header-background/90 shadow-sm sticky top-0 z-10">
      <Link to="/" className="flex items-center gap-4">
        {/* === CHANGED ===
          Increased logo size from size-12 to size-16 (4rem / 64px).
        */}
        <div className="size-14">
          <img
            alt="Karnataka Seal"
            className="h-full w-full object-contain"
            src="/logo.png" 
          />
        </div>
        <div className="flex flex-col">
          <span className="text-sm font-semibold leading-tight text-text-main">Government of Karnataka</span>
          <h1 className="text-xl font-bold leading-tight tracking-[-0.015em] text-text-main">
            Department of Mines and Geology
          </h1>
        </div>
      </Link>
    </header>
  );
}

export default DetailsHeader;
